import { get, post, excel } from '../request.js';

/**
 * 查询字典列表
 */
export async function queryDictionary(params) {
  return get('/api/analysis/basic/dict_cfg', params);
}

/**
 * 分页查询下载列表
 */
export async function pageDownloads(params) {
  return get('/api/common/download/page', params);
}

/**
 * 删除下载任务
 */
export async function deleteDownload(params) {
  return post('/api/common/download/remove', params);
}

/**
 * 下载文件并改名
 */
export async function downloadExcel(params) {
  return excel('/api/common/download/download', params);
}

/**
 * 创建下载任务
 */
export async function downloadTask(params) {
  return post('/api/common/download/create_download_task', params)
}

/**
 * 获取自定义列
 */
export async function queryCustomFields(params) {
  return get('/api/system/fields/query_by_code', params);
}

/**
 * 保存自定义列
 */
export async function saveCustomFields(params) {
  return post('/api/system/fields/save', params);
}

